import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';


@Injectable({
  providedIn: 'root'
})
export class MaterialService {
  materials: any = [];
  constructor(private http: HttpClient) {
    this.materials = [];
    console.log("materials initialized!!!!!!!", this.materials)
  }

  addMaterial(data: any): Observable<any> {
    console.log("Adding materials", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "materials", data).subscribe((res: any) => {

        observer.next(res.data.material);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }
  editMaterial(data: any): Observable<any> {
    console.log("Edit materials", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "materials", data).subscribe((res: any) => {
        console.log("Edited Material : ", res);
        observer.next(res.data.materialData);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  deleteMaterial(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "materials?_id=" + id).subscribe((res: any) => {
        console.log("Deleted Material Response in service = ", res);
        observer.next(res.data.material);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }

  getMaterial(id): Observable<any> {
    console.log("Getting materials");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "materials?_id=" + id).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.material);
        observer.complete();
      })

    });
  }

  getMaterialUsingJobId(id): Observable<any> {
    console.log("Getting materials");
    let that = this;
    let obj = {
      _id: id
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/assignment", obj).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.finalArray);
        observer.complete();
      })

    });
  }


  getAssignmentListForChild(id): Observable<any> {
    console.log("Getting materials");
    let that = this;
    let obj = {
      _id: id
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/learner-assignment", obj).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });
  }

  getQuziOfMaterial(id): Observable<any> {
    console.log("Getting materials");
    let that = this;
    let obj = {
      _id: id
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/assignment-quiz", obj).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.finalArray);
        observer.complete();
      })

    });
  }

  getMaterialUsingJobIdWithNoGroup(id): Observable<any> {
    console.log("Getting materials");
    let that = this;
    let obj = { _id: id }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/assignment/group", obj).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.assignment);
        observer.complete();
      })

    });
  }

  getAllMaterials(): Observable<any> {
    console.log("Getting all the materials")
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "materials").subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getmaterialsByCourseId(jobId): Observable<any> {
    console.log("job id", jobId)
    console.log("Getting materials");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "materials?job=" + jobId).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.materials);
        observer.complete();
      })

    });
  }


  assignmentStatusWithLearner(data): Observable<any> {
    console.log("Getting materials========>>>>>>>", data);
    let that = this;
    // let obj = {
    //   _id: jobId
    // }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/assignment-status", data).subscribe((res: any) => {
        observer.next(res.data.assignment);
        observer.complete();
      })
    });
  }



  quizStatusWithLearner(data): Observable<any> {
    console.log("Getting materials========>>>>>>>", data);
    let that = this;
    // let obj = {
    //   _id: jobId
    // }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/quiz-status", data).subscribe((res: any) => {
        observer.next(res.data.mainSendArray);
        observer.complete();
      })
    });
  }


  allAllotedAssignmentUsingJobId(jobId): Observable<any> {
    console.log("Getting materials");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "jobs/all-assignment?_id=" + jobId).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.assignment);
        observer.complete();
      })

    });
  }

  filterAllotedAssignment(body): Observable<any> {
    console.log("Getting materials", body);

    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "jobs/filter-assignment", body).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.assign);
        observer.complete();
      })

    });
  }

  getCourseUnits(body): Observable<any> {
    console.log("Getting Course Id services ", body);

    let that = this;
    return new Observable<any>((observer) => {
      this.http
        .get(config.baseApiUrl + "course-folder/?course=" + body)
        .subscribe((res: any) => {
          observer.next(res.data);
          observer.complete();
        })

    });
  }

}
